import { Box, Button, makeStyles, TextField, Typography, withStyles } from "@material-ui/core";
import { blue } from "@material-ui/core/colors";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { loggingOut, loggingOutSuccess, loginAttempSuccess } from "../action/loginAction";
import { clearAll, sessionEnd, submitStudentsSuccess } from "../action/studentAction";
import { dashboardRef } from "../firebase/firebaseModel";
import Error from "./Error";
import Loading from "./Loading";


const useStyles = makeStyles({
    container: {
        minHeight: "100vh",
        height: "fit-content",
        minWidth: "515px",
        width: "100vw",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: "20px",
        padding: "50px 30px",
    },
    error: {
        color: "red",
    },
    avatar: {
        width: "50px",
        height: "50px",
        cursor: "pointer",
        backgroundColor: "red",
        position: "absolute",
        top: "10px",
        right: "10px",
        borderRadius: "50%",
        "&:hover": {
            opacity: "0.7",
        }
    },
    textArea: {

    },
    cardContainer: {
        height: "fit-content",
        minWidth: "515px",
        width: "100%",
        display: "flex",
        flexWrap: "wrap",
        gap: "20px",
        backgroundColor: "white"
    },
    card: {
        height: "fit-content",
        minWidth: "200px",
        width: "33%",
        maxWidth: "300px",
        display: "flex",
        flexDirection: "column",
    },
    title: {
        color: blue[900],
    },
    dashContainer: {
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        paddingTop: "20px",
        flexWrap:"wrap"
    },
    statusContainer: {
        display: "flex",
        gap: "30px",
        alignItems: "center"
    }
});

const ColorButton = withStyles((theme) => ({
    root: {
        color: theme.palette.getContrastText(blue[900]),
        backgroundColor: blue[900],
        fontSize: "18px",
        '&:hover': {
            backgroundColor: blue[700],
        },
    },
}))(Button);

export default function Dashboard() {
    let history = useHistory();
    let user = useSelector(state => state.userState);
    let studentState = useSelector(state => state.studentState);
    let logOut = async () => {
        if (window.confirm("Are you sure you want to log out?")) {
            dispatch(loggingOut());
            await new Promise(resolve => setTimeout(resolve, 2000));
            localStorage.clear();
            dispatch(loggingOutSuccess());
            history.push("/");
        }
    }
    let gotoSubmit = () => history.push("/studentSubmission")

    let classes = useStyles();
    let dispatch = useDispatch();
    useEffect(() => {
        let teacherID = "";
        if (!user.user.email) {
            let loginData = JSON.parse(localStorage.getItem("UserLogin"));
            if (loginData.email) dispatch(loginAttempSuccess(loginData));
            teacherID = loginData.email.replace(".", "_");
        }
        else teacherID = user.user.email.replace(".", "_");
        dashboardRef.doc(teacherID).collection("Student").onSnapshot((querySnapshot) => {
            var student = [];
            console.log("snapshot?", querySnapshot)
            querySnapshot.forEach((doc) => {
                let newObj = doc.data();
                newObj["id"] = doc.id;
                student.push(newObj);
            });
            student.sort((a, b) => {
                if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
                if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
                return 0;
            })
            dispatch(submitStudentsSuccess(student));
        });
        // eslint-disable-next-line
    }, [])

    let endSession = () => {
        if (window.confirm("Are you sure you want to end session?")) {
            console.log("TEACHERID: ", user.user.email.replace(".", "_"))
            dispatch(sessionEnd(user.user.email.replace(".", "_"), gotoSubmit))
        }
    }

    let clearAllAnswers = ()=>{
        dispatch(clearAll(user.user.email.replace(".","_"),studentState.students,user));
    }
    return (
        <>
            {!user.loggingOut &&
                <Box className={classes.container} >
                    <img src={user.user.image} className={classes.avatar} onClick={() => logOut()} alt="Log out" />
                    {user.error + studentState.error !== "" &&
                        <Error error={user.error ? user.error : studentState.error} />
                    }
                    {user.error + studentState.error === "" &&
                        <>
                            <Box className={classes.dashContainer}>
                                <Box className={classes.statusContainer}>
                                    <Typography variant="h2">
                                        Dashboard
                                    </Typography>
                                    <ColorButton variant="contained" onClick={clearAllAnswers} >Clear answers</ColorButton>
                                </Box>

                                <Box className={classes.statusContainer}>
                                    <Typography variant="h6">
                                        {studentState.endingSession && "Ending Session . . ."}
                                        {studentState.clearingResult && "Clearing Answers . . ."}
                                    </Typography>
                                    <Button variant="contained" style={{ fontSize: "16px" }} onClick={endSession}>
                                        End Session
                                    </Button>
                                </Box>
                            </Box>

                            <Typography variant="h6">
                                Student Link <a href={window.location.href.substr(0, window.location.href.split("").lastIndexOf("/") + 1) + "student/" + user.user.link}> {window.location.href.substr(0, window.location.href.split("").lastIndexOf("/") + 1) + "student/" + user.user.link}</a>
                            </Typography>
                            <Box className={classes.cardContainer}>
                                {studentState.students.map(e => {
                                    return (
                                        <Box key={e.id + Date.now()} className={classes.card} >
                                            <Typography variant="subtitle2" className={classes.title}>
                                                {e.name}
                                            </Typography>
                                            <TextField key={e.id + Date.now()}
                                                className={classes.textArea}
                                                multiline
                                                defaultValue=""
                                                rows={5}
                                                variant="outlined"
                                                value={e.answer}
                                            />
                                        </Box>)
                                })
                                }
                            </Box>
                        </>
                    }

                </Box>
            }
            {user.loggingOut &&
                <Loading />
            }
        </>
    )
}